import { render } from "./TermosDeUso.vue?vue&type=template&id=56d63d0f&scoped=true"
import script from "./TermosDeUso.vue?vue&type=script&lang=js"
export * from "./TermosDeUso.vue?vue&type=script&lang=js"

import "./TermosDeUso.vue?vue&type=style&index=0&id=56d63d0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d63d0f"]])

export default __exports__